
import { useState, useCallback } from 'react'
import { ShippingOrder } from '../DeShippingTableWrapper'

export function useOrderSelection(orders: ShippingOrder[]) {
  const [selectedOrder, setSelectedOrder] = useState<ShippingOrder | null>(null)
  const [selectedOrders, setSelectedOrders] = useState<ShippingOrder[]>([])

  // Selection management functions
  const selectOrder = useCallback((order: ShippingOrder) => {
    setSelectedOrders(prev => 
      prev.includes(order) ? prev : [...prev, order]
    )
  }, [])

  const deselectOrder = useCallback((order: ShippingOrder) => {
    setSelectedOrders(prev => prev.filter(o => o.order_id !== order.order_id))
  }, [])

  const toggleOrderSelection = useCallback((order: ShippingOrder) => {
    setSelectedOrders(prev => {
      const isCurrentlySelected = prev.some(o => o.order_id === order.order_id);
      const newSelection = isCurrentlySelected 
        ? prev.filter(o => o.order_id !== order.order_id)
        : [...prev, order];
      return newSelection;
    })
  }, [])

  const selectAllOrders = useCallback(() => {
    setSelectedOrders(orders)
  }, [orders])

  const clearSelection = useCallback(() => {
    setSelectedOrders([])
  }, [])

  const syncSelectedOrders = useCallback(() => {
    setSelectedOrders(currentSelected => {
      if (currentSelected.length === 0) return currentSelected;
      
      // Map selected order IDs to fresh order objects and filter based on current orders
      const selectedIds = currentSelected.map(order => order.order_id);
      const freshSelectedOrders = orders.filter(order => 
        selectedIds.includes(order.order_id)
      );
      
      return freshSelectedOrders;
    });
  }, [orders])

  const isOrderSelected = useCallback((order: ShippingOrder) => {
    return selectedOrders.some(o => o.order_id === order.order_id)
  }, [selectedOrders])

  const getSelectedOrdersCount = useCallback(() => {
    return selectedOrders.length
  }, [selectedOrders])

  const getSelectedOrdersData = useCallback(() => {
    return orders.filter(order => selectedOrders.some(o => o.order_id === order.order_id))
  }, [orders, selectedOrders])

  return {
    selectedOrder,
    selectedOrders,
    setSelectedOrder,
    selectOrder,
    deselectOrder,
    toggleOrderSelection,
    selectAllOrders,
    clearSelection,
    isOrderSelected,
    getSelectedOrdersCount,
    getSelectedOrdersData,
    syncSelectedOrders,
  }
} 